/**
 * 把js字面量对象序列化成url查询字符串格式
 * @param obj
 * @returns {string}
 */
export function serializeParams(obj) {
  let params = []
  for (let i in obj) {
    params.push(encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]))
  }
  return params.join("&")
}

export function jsonp(options) {
  return new Promise((resolve, reject) => {
    options = options || {}
    options.timer = 8000

    if (!options.url || !options.jsonpCallbackName) {
      throw new Error("参数不合法")
    }

    //创建 script 标签并加入到页面中
    let callbackName = options.jsonpCallbackName
    let head = document.getElementsByTagName("head")[0]
    let params = serializeParams(options.data)
    let script = document.createElement("script")
    script.async = true
    head.appendChild(script)

    //创建jsonp回调函数
    window[callbackName] = function(json) {
      head.removeChild(script)
      clearTimeout(script.timer)
      window[callbackName] = null
      resolve(json)
    }

    script.onerror = reject
    //超时处理
    if (options.timer) {
      script.timer = setTimeout(function() {
        window[callbackName] = null
        head.removeChild(script)
        reject({ msg: "超时" })
      }, options.timer)
    }

    //发送请求
    script.src = options.url + "?" + params
  })
}

export function ajax(options = {}) {
  let promise = new Promise(function(resolve, reject) {
    options.type = (options.type || "GET").toUpperCase()
    options.dataType = options.dataType || "json"
    options.timeout = options.timeout || 10000

    let params = serializeParams(options.params),
      data = options.contentType == "json" ? JSON.stringify(options.data) : options.data,
      xhr = new XMLHttpRequest()
    xhr.responseType = options.dataType
    xhr.withCredentials = !!options.withCredentials
    xhr.onreadystatechange = function() {
      if (xhr.readyState == 4) {
        if (xhr.status >= 200 && xhr.status < 300) {
          if (xhr.responseType == "json") {
            resolve(xhr.response)
          } else {
            resolve(JSON.parse(xhr.response))
          }
        } else {
          reject(xhr)
        }
      }
    }
    xhr.onerror = reject

    //连接 和 发送 - 第二步
    if (options.type == "GET") {
      xhr.open("GET", `${options.url}${params ? "?" + params : ""}`)
      xhr.send(null)
    } else if (options.type == "POST") {
      xhr.open("POST", `${options.url}${params ? "?" + params : ""}`, true)
      //设置表单提交时的内容类型
      xhr.setRequestHeader("Content-Type", options.requestContentType || "application/x-www-form-urlencoded")
      xhr.send(data)
    }

    setTimeout(function() {
      if (xhr.readyState != 4) {
        reject(new Error("ajax request timeout"))
      }
    }, options.timeout)
  })

  return promise
}

export function getScript(url, scriptCharset = "utf-8") {
  return new Promise((resolve, reject) => {
    let script = document.createElement("script")
    script.type = "text/javascript"
    script.onerror = reject
    script.onload = resolve
    script.src = url
    script.charset = scriptCharset
    document.body.appendChild(script)
  })
}
